// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import toast from 'react-hot-toast'

// ** Axios Imports
import axios from 'axios'

export const addNews = createAsyncThunk('news/addNews', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/addnews', params)
  if (response.data.status) {
    toast.success(response.data.message)
    return response.data
  } else toast.error(response.data.message)
})

export const getNews = createAsyncThunk('news/getNews', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/getAdminNews', params)
  return response.data
})
export const updateNews = createAsyncThunk('news/updateNews', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/changeNewsStatus', params)
  if (response.data.status) {
    toast.success(response.data.message)
    return response.data
  } else toast.error(response.data.message)
})
export const newsSlice = createSlice({
  name: 'news',
  initialState: {
    addNewsStatus: null,
    data: [],
    allData: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(addNews.fulfilled, (state, action) => {
        state.addNewsStatus = action.payload
      }).addCase(getNews.fulfilled, (state, action) => {
        state.data = action.payload.news
        state.allData = action.payload.allData
      }).addCase(updateNews.fulfilled, (state, action) => {
        state.addNewsStatus = action.payload
      })
  }
})

export default newsSlice.reducer
